import { Token } from '../../../../api/DynaVaultsAPI';
import { CHAINS } from '@dapp/multi-lib/network';
import { TOKENS } from 'utils/constants/tokens';

interface DepositToken extends Token {
  available: boolean;
}

interface DepositTokenList {
  [chainId: number]: DepositToken[];
}

export const depositTokenList = {
  [CHAINS.ETH_FORKED]: [
    {
      symbol: 'USDC',
      name: 'USDC',
      address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      decimals: 6,
      available: true,
    },
    {
      symbol: 'SDAO',
      name: 'SDAO',
      address: '0x993864E43Caa7F7F12953AD6fEb1d1Ca635B875F',
      decimals: 18,
      available: true,
    },
    {
      symbol: 'WETH',
      name: 'WETH',
      address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      decimals: 18,
      available: process.env.NEXT_PUBLIC_NODE_ENV === 'development',
    },
  ],
  [CHAINS.BASE_L2]: [
    {
      ...TOKENS.BASE_L2.USDC,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.USDT,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.WETH,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.cbBTC,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.EURC,
      available: true,
    },
  ],
  [CHAINS.ETH_MAINNET]: [
    {
      symbol: 'USDC',
      name: 'USDC',
      address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
      decimals: 6,
      available: true,
    },
    {
      symbol: 'USDT',
      name: 'USDT',
      address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
      decimals: 6,
      available: true,
    },
    {
      symbol: 'WETH',
      name: 'WETH',
      address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
      decimals: 18,
      available: process.env.NEXT_PUBLIC_NODE_ENV === 'development',
    },
  ],
} as const satisfies DepositTokenList;

export const getDepositTokenList = (chainId: number): DepositToken[] => {
  const listOfTokens: DepositToken[] =
    (depositTokenList as DepositTokenList)[chainId] || [];
  return listOfTokens.filter((item) => item.available);
};
